// src/components/ServicesTableHead.js

import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, TableSortLabel } from '@mui/material';

function ServicesTableHead({ columns, order, orderBy, onSortRequest }) {
  return (
    <TableRow>
      {columns.map((column) => (
        <TableCell key={column.id}>
          {column.sortable ? (
            <TableSortLabel
              active={orderBy === 'date'}
              direction={order}
              onClick={() => onSortRequest(column.id)}
            >
              {column.label}
            </TableSortLabel>
          ) : (
            column.label
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}

ServicesTableHead.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      sortable: PropTypes.bool.isRequired,
    })
  ).isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  onSortRequest: PropTypes.func.isRequired,
};

export default ServicesTableHead;